var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== ""
    ? _c(
        "el-tooltip",
        {
          attrs: {
            content: _vm.textTooltip,
            placement: _vm.placementTooltip,
            "open-delay": _vm.openDelayTooltip,
            "visible-arrow": false
          }
        },
        [
          _c("i", {
            directives: [
              {
                name: "clipboard",
                rawName: "v-clipboard:copy",
                value: _vm.data,
                expression: "data",
                arg: "copy"
              },
              {
                name: "clipboard",
                rawName: "v-clipboard:success",
                value: _vm.onCopy,
                expression: "onCopy",
                arg: "success"
              },
              {
                name: "clipboard",
                rawName: "v-clipboard:error",
                value: _vm.onError,
                expression: "onError",
                arg: "error"
              }
            ],
            class: ["copy-btn", _vm.icon],
            on: {
              click: function($event) {
                return _vm.$emit("clicked")
              }
            }
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }